<div class="liked-photos">
  
  <h1 class="title">Liked</h1>

  <span *ngIf="display.length == 0" class="no-photos">
    Liked images will show up here, go like some photos!
  </span>

  <ngx-masonry *ngIf="display.length > 0" class="liked-photos-container">
    <div ngxMasonryItem class="liked-photos-col" *ngFor="let photo of display">
      <div class="liked-photo">
        <img class="liked-image" [src]="photo.img_src" 
          alt="{{ photo.rover.name }} caught by {{ photo.camera.full_name }}" aria-label="click to zoom in"/>
        <div class="button-container">
          <button mat-icon-button [attr.aria-label]="photo.liked ? 'unlike image' : 'like image'" (click)="like(photo.liked, photo.id)">
            <mat-icon class="star" *ngIf="!photo.liked">star_border</mat-icon>
            <mat-icon class="star" *ngIf="photo.liked">star</mat-icon>
          </button>
        </div>
        <div class="liked-description">
          <span class="details">{{ photo.rover.name }} - {{ photo.camera.full_name }}</span>
          <span class="date">{{ photo.earth_date }}</span>
          <p class="source">Brought to you by NASA's Rover Photos API</p>
        </div>
      </div>
    </div>
  </ngx-masonry>

  <div class="button-container">
    <button aria-label="show more images" class="show-more" *ngIf="limit < likedPhotos.length" 
      (click)="increaseLimit()">
      Show More Images<mat-icon class="arrow">keyboard_arrow_down</mat-icon>
    </button>
  </div>
</div>